import * as AppConstants from "AppConstants";

/**
 * Builds client-project endpoint URLs by substituting placeholders in the AppConstants
 * templates, the same way activitiesEndpointUtil does for activity types.
 *
 * A "client project" here is the project an activity is logged against, served by
 * client-management. It is a different concept from the phase-2 project-service project
 * (milestones, budget, resource allocation), which project.service.js talks to.
 *
 * @since NEXT_VERSION
 */

/** GET /v1/api/projects — every project, for the master data grid. @since NEXT_VERSION */
export const getUrlForAllClientProjects = () => AppConstants.GET_CLIENT_PROJECTS_ENDPOINT;

/**
 * GET /v1/api/projects/by-client/{clientId}?activeOnly=true — feeds the Add Activity dropdown,
 * so deactivated projects are excluded and cannot be selected for new work.
 * @since NEXT_VERSION
 */
export const getUrlForActiveClientProjectsByClient = (clientId) =>
  AppConstants.GET_ACTIVE_CLIENT_PROJECTS_BY_CLIENT_ENDPOINT.replace(
    AppConstants.CLIENT_ID_PLACEHOLDER,
    clientId
  );

/**
 * GET /v1/api/projects/by-client/{clientId} — unfiltered, for screens that must also show
 * deactivated projects.
 * @since NEXT_VERSION
 */
export const getUrlForClientProjectsByClient = (clientId) =>
  AppConstants.GET_CLIENT_PROJECTS_BY_CLIENT_ENDPOINT.replace(
    AppConstants.CLIENT_ID_PLACEHOLDER,
    clientId
  );

/** POST /v1/api/projects. @since NEXT_VERSION */
export const getUrlForAddClientProject = () => AppConstants.ADD_CLIENT_PROJECT_ENDPOINT;

/** PUT /v1/api/projects/{projectId}. @since NEXT_VERSION */
export const getUrlForUpdateClientProject = (id) =>
  AppConstants.UPDATE_CLIENT_PROJECT_ENDPOINT.replace(
    AppConstants.CLIENT_PROJECT_ID_PLACEHOLDER,
    id
  );

